import { observer } from 'mobx-react-lite'

import { schema } from '@showrunner/prose-schemas'

import { Toolbar } from '#components/Toolbar'
import { buildShortcutTip, Keys } from '#hooks'
import { useMst } from '#state'
import { toggleCaps } from '#util'

import { ColorPickerPopover } from './ColorPickerPopover'
import { SpacingMenu } from './SpacingMenu'

export const StyleButtons = observer(function StyleButtons() {
  const { currentScript } = useMst()
  const observableEditor = currentScript?.observableEditor

  const restricted = !!currentScript?.readOnlyByPlan
  const disabled = restricted || !observableEditor?.canFormatText

  if (!observableEditor) return null

  const color = observableEditor.selectionColor
  const bgColor = observableEditor.selectionBgColor

  return (
    <>
      <Toolbar.MarkButton
        mark={schema.marks.strong}
        label="Bold"
        icon="fa-bold"
        disabled={disabled}
      />
      <Toolbar.MarkButton
        mark={schema.marks.em}
        label="Italic"
        icon="fa-italic"
        disabled={disabled}
      />
      <Toolbar.MarkButton
        mark={schema.marks.underline}
        label="Underline"
        icon="fa-underline"
        disabled={disabled}
      />
      <Toolbar.MarkButton
        mark={schema.marks.strike}
        label="Strikethrough"
        icon="fa-strikethrough"
        disabled={disabled}
      />
      <Toolbar.EditorButton
        command={toggleCaps}
        tooltip={`Change case ${buildShortcutTip([Keys.CMD, Keys.ALT, 'A'])}`}
        icon="fa-font-case"
        disabled={disabled}
      />
      <ColorPickerPopover
        editorView={observableEditor.editorView}
        color={color}
        bgColor={bgColor}
        active={!(color === '' && bgColor === '')}
        disabled={disabled}
      />
      <SpacingMenu
        script={currentScript}
        disabled={restricted || !observableEditor.singleBlockTextSelection}
      />
    </>
  )
})
